import React from 'react'
import PropTypes from 'prop-types'
import { FlagIcon, getFlagByCode, Icon } from '@maui/elements'
import get from 'lodash/get'

const NoCountryAffiliation = ['Financial Gain', 'Unknown']

export const getCountryCode = actor => {
  const countryCode = get(actor, 'locations.source.[0].country.iso2')
  const { locations = [], motivations = [] } = actor || {}
  return (locations?.source?.length === 1 && !NoCountryAffiliation.includes(motivations))
    ? countryCode
    : undefined
}

const ActorIcon = ({ actor, countryCodeAvailable, ...props }) => {
  const countryCode = countryCodeAvailable ? countryCodeAvailable.toLowerCase() : getCountryCode(actor)

  return getFlagByCode(countryCode)
    ? <FlagIcon {...props} code={countryCode} fallback={false} />
    : <Icon name='user-secret' {...props} />
}

ActorIcon.propTypes = {
  actor: PropTypes.shape({
    countryCode: PropTypes.string,
    motivations: PropTypes.arrayOf(PropTypes.string),
    sourceLocations: PropTypes.arrayOf(PropTypes.shape({
      countryCode: PropTypes.string,
    })),
  }),
  countryCodeAvailable: PropTypes.string,
}

export default ActorIcon
